export default "__VITE_ASSET__Dm_zm9Qu__"